import { useLocation } from './routing';

export const useNavigation = () => {
  const location = useLocation();

  return {
    activePathname: location.pathname,
  };
};
